"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractConstraintConverter_1 = require("./AbstractConstraintConverter");
/**
 * SimpleConstraintConverter.
 *
 * @author RV
 */


var SimpleConstraintConverter =
/*#__PURE__*/
function (_AbstractConstraintCo) {
  _inherits(SimpleConstraintConverter, _AbstractConstraintCo);

  function SimpleConstraintConverter() {
    _classCallCheck(this, SimpleConstraintConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleConstraintConverter).apply(this, arguments));
  }

  return SimpleConstraintConverter;
}(AbstractConstraintConverter_1.AbstractConstraintConverter);

exports.SimpleConstraintConverter = SimpleConstraintConverter;